import { h, ComponentChildren } from "preact";
import { useRef } from "preact/hooks";
import { Trans } from "@lingui/react/macro";
import MoneyFormatter from "../../../../utils/money-formatter";
import { PaymentNotification } from "../../../../../../services/payment-gateway";
import { GatewayContainer, TransactionPollingPage } from "../shared/components";

interface WithdrawAmountPageProps {
	requestWithdraw: (amount: string) => void;
	showMaxAmount?: {
		altDesc?: string;
		description: ComponentChildren;
		value: number;
	} | null;
}
export function WithdrawAmountPage({ requestWithdraw, showMaxAmount = null }: WithdrawAmountPageProps) {
	const form = useRef<HTMLFormElement>();
	return <GatewayContainer>
		<form
			class="flex flex-col items-center gap-2 w-full"
			ref={form}
			onSubmit={e => {
				e.preventDefault();
				requestWithdraw(new FormData(form.current).get('amount').toString())
			}}
		>
			<div class="w-full text-4xl font-light pb-2"><Trans>Withdraw</Trans></div>
			<div class="w-full">
				<div class="text-sm"><Trans>Amount</Trans></div>
				<div class="h-8 w-full flex">
					<input class="border h-full rounded-s bg-slate-100 border-slate-300 text-slate-800 py-2 px-3 w-16 text-base" disabled={true} value="ETB" />
					<input class="border border-l-0 h-full rounded-e bg-white border-slate-300 text-slate-950 py-2 px-3 text-base grow"
						required={true}
						name="amount"
						type="number"
						step="1"
						min="10"
						max={String(showMaxAmount && showMaxAmount.value)}
					/>
				</div>
				{showMaxAmount == null ? null : <div class="w-full text-sm text-slate-500 pt-1 text-right">
					{!showMaxAmount.altDesc ? null : <span class='block text-xs'>{showMaxAmount.altDesc}</span>}
					<span>{showMaxAmount.description}:</span> <MoneyFormatter value={showMaxAmount.value} />
				</div>}
			</div>
			<div class="w-full py-2 flex justify-center">
				<input type="submit" value="Withdraw" class="mx-auto px-5 py-3 text-center rounded bg-emerald-600 text-slate-50 border-emerald-700 text-xl" />
			</div>
		</form>
	</GatewayContainer>
}

interface TransactionPollingComponentProps {
	statusUrl: string;
	onEvent: (status: PaymentNotification) => void;
}

export function ProcessingWithdrawPage({ statusUrl, onEvent }: TransactionPollingComponentProps) {
	return <TransactionPollingPage statusUrl={statusUrl} onEvent={onEvent}>
		<span class="text-4xl text-green-500 text-center"><Trans>Please wait</Trans></span>
		<span class="text-base"><Trans>Please wait while we credit your amount</Trans></span>
	</TransactionPollingPage>;
}